import axios from "axios";
import React, { useEffect, useState } from "react";
import "./pagination.css";
import { NavBar } from "../navbar/navbar";
import { Pagination } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addItem } from "../../redux/store";

export function PaginationComp() {
  const [data, setData] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(5); // Products per page
  const [currentProducts, setCurrentProducts] = useState([]); // Products to display on the current page
  const [load, setLoad] = useState(false);
  const dispatch=useDispatch();
  const navigate=useNavigate();

  useEffect(() => {
    // Fetch all products initially
    setLoad(true);
    axios.get("https://fakestoreapi.com/products").then((response) => {
      setLoad(false);
      setData(response.data);
      setCurrentProducts(response.data.slice(0, productsPerPage)); // Set products for the first page
    });
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    setCurrentProducts(data.slice(startIndex, endIndex)); // Paginate locally
  };
   function handleAddClick(item) {
         dispatch(addItem(item));
         navigate("/Cart");
         
     }
  return (
    <div className="pagination-container">
      <NavBar />
      <div className="title-part">
        <h3 className="page-title">Choose your choice</h3>
        <div className="pagination-comp">
          {/* Ant Design Pagination */}
          <Pagination
            current={currentPage}
            pageSize={productsPerPage}
            total={data.length} // Total number of products
            onChange={handlePageChange} // Update displayed products
            showSizeChanger={false} // Disable page size changes
          />
        </div>
      </div>

    
      {load && <div className="loader"></div>}

    
      <div className="cards-part-page">
        {currentProducts.map((item) => (
          <div className="card page-card" key={item.id}>
            <div className="card-header page-card-header">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="card-body page-card-body">
              <div>
                <span className="fw-bold">Title: </span>
                {item.title}
              </div>
              <div>
                <span className="fw-bold">Price: </span>
                ${item.price}
              </div>
              <div>
                <span className="fw-bold">Description: </span>
                {item.description}
              </div>
            </div>
            <div className="card-footer">
              <button className="btn w-100" style={{ backgroundColor: "orange", color: "white" }} onClick={()=>handleAddClick(item)}>
                Add Cart
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
